module.exports = __webpack_public_path__ + "static/img/prime_stroke.1f4f4472.svg";